<form class="drop-padding" (ngSubmit)="save()">
  <mat-form-field appearance="outline">
    <mat-label>Цена</mat-label>
    <input matInput type="number" placeholder="Цена" [formControl]="priceControl" />
  </mat-form-field>
  <button mat-flat-button [disabled]="loading" type="submit" color="primary">
    {{ loading ? 'Загрузка...' : 'Сохранить' }}
  </button>
</form>
